import moment from 'moment-timezone/builds/moment-timezone-with-data-2012-2022.min';
import Media from './Media'; // Adds ~503kb

const GRADIENTS = [
  {
    start: [246, 195, 196],
    end: [227, 217, 237],
  },
  {
    start: [174, 194, 244],
    end: [241, 193, 193],
  },
  {
    start: [50, 63, 141],
    end: [221, 253, 244],
  },
  {
    start: [125, 210, 212],
    end: [231, 233, 226],
  },
];

export default class Sequence {
  static defaultLocalisation = {
    lat: 0,
    long: 0,
  };
  // R, G, B
  static colors = GRADIENTS.map((g, i) => ({
    id: i,
    ...g,
    nStart: g.start.map(v => v / 255),
    nEnd: g.end.map(v => v / 255),
  }));
  static currentColor = undefined;
  static getRandomColors() {
    const colors = Sequence.colors
      .filter(c => c !== Sequence.currentColor);

    Sequence.currentColor = colors[Math.floor(Math.random() * colors.length)];

    return {
      ...Sequence.currentColor,
    };
  }
  constructor(params = {}) {
    const medias = params.medias || [];
    // Reading
    this.duration = 7000;
    this.startAt = params.startAt || 0;
    this.endAt = this.startAt + this.duration;
    this.order = params.order || 0;

    // API
    this.id = `id${Math.random().toString(36).substr(2, 9)}`; // TODO
    this.uno = params.uno;
    this.country = params.country || 'WORLD';
    this.city = params.city || '';
    this.functions = params.entity_function || [];
    this.compagny = params.entity_company || [];
    this.provider = params.provider || [];
    this.source = params.source || '';
    this.keyword = params.keyword || [];
    this.advisory = params.advisory || '';
    this.urgency = params.urgency || 5;
    this.mediasactus = params.entity_media || [];
    this.channel = params.channel || [];
    this.headline = params.headline || '';
    this.creator = params.creator || '';
    this.location = params.entity_location || '';
    this.organisation = params.entity_organisation || '';
    this.rules = params.rules || '';
    this.persons = params.entity_person || [];
    this.title = params.title || '';
    this.description = params.description || '';
    this.content = params.content || [];
    this.published = new Date(params.published);
    this.slugs = params.slugs || [];
    this.topics = params.topics || [];
    this.location = params.location || Sequence.defaultLocalisation;
    this.city = params.city || '';
    this.video = params.video || false;
    this.medias = medias.map(bagItem => new Media(bagItem, params.entity_faces));
    this.colors = Sequence.getRandomColors();
  }
  from() {
    return `${this.city}, ${this.country}`;
  }
  getMedia(n = 0) {
    return this.medias[n] || new Media();
  }
  getTexture() {
    return this.getMedia().getTexture();
  }
  getLargeImage() {
    return this.getMedia().getImage();
  }
  getLargeHref() {
    return this.getMedia().getPhoto().href;
  }
  getSmallImage() {
    return this.getMedia().getImage('Preview');
  }
  getSmallHref() {
    return this.getMedia().getPhoto('Preview').href;
  }
  getvideo() {
    const video = this.video;
    let result = false;
    if (video.length > 0) {
      result = `<video class="o-player__video" autoplay muted><source src="${video}" type="video/mp4"></video>`;
    }
    return result;
  }
  getDate() {
    return moment(this.published).tz('Europe/Paris').format('HH:mm - DD.MM');
  }
  getContent() {
    const content = this.content;
    let result = '';
    for (let i = 0; i < content.length; i += 1) {
      result += `<p>${content[i]}</p>`;
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/models/Sequence.js